import { defineStore } from 'pinia'

import { createShippingLabelsActions } from './actions'
import { createShippingLabelsState } from './state'

export const useShippingLabelsStore = defineStore('shippingLabels', () => {
    const state = createShippingLabelsState()
    const actions = createShippingLabelsActions(state)

    return {
        ...state,
        ...actions
    }
})
